import { render, staticRenderFns } from "./faultMsg.vue?vue&type=template&id=80890f78&scoped=true&"
import script from "./faultMsg.vue?vue&type=script&lang=js&"
export * from "./faultMsg.vue?vue&type=script&lang=js&"
import style0 from "./faultMsg.vue?vue&type=style&index=0&id=80890f78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80890f78",
  null
  
)

export default component.exports